<template>
  <main>
    <PageIntro v-if="appLogin === false" :heading="'CREATE A FREE DIGITAL ACCOUNT'" :body="''" />
    <Registration />
    <FooterShout v-if="appLogin === false" :type="'signin'" />
  </main>
</template>

<script>
import Registration from '@/components/Registration'
import PageIntro from '@/components/PageIntro'
import FooterShout from '@/components/FooterShout'

export default {
  components: {
    Registration,
    PageIntro,
    FooterShout
  },
  data() {
    return {
      appLogin: false
    }
  },
  mounted() {
    // if they are coming from the app specific login URL adapt the page accordingly
    if (this.$router.currentRoute.name === 'app-register') {
      this.appLogin = true
    }
  },
}
</script>
